import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffOutlinedIcon from '@material-ui/icons/HighlightOffOutlined';
import { IInvoiceForwardingRecord } from 'gen/ApiClient';
import React from 'react';

interface IProps {
	item: IInvoiceForwardingRecord;
	style?: React.CSSProperties;
}

export const InvoiceForwardingRecordListItemStatusIcon = ({ item, style }: IProps) => {
	if (item.isForwarded) {
		return <CheckCircleOutlineIcon style={style} />;
	} else if (item.isIgnored) {
		return <HighlightOffOutlinedIcon style={style} />;
	} else {
		return <BlockIcon style={style} />;
	}
};
